import { render, staticRenderFns } from "./Cruscotto.vue?vue&type=template&id=0fa88ac4&scoped=true"
import script from "./Cruscotto.vue?vue&type=script&lang=js"
export * from "./Cruscotto.vue?vue&type=script&lang=js"
import style0 from "./Cruscotto.vue?vue&type=style&index=0&id=0fa88ac4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa88ac4",
  null
  
)

export default component.exports